import { create } from 'zustand'
import type { ThreatLevel } from '@/lib/criteria/levels'

/**
 * Global current threat level for the active location. Set by the Home view once
 * NWS alerts + SPC risk resolve; read by the AppShell (ambient glow / theme-color)
 * and, in Milestone 2, by the Storm-Mode activation trigger.
 */
interface ThreatState {
  level: ThreatLevel
  setLevel: (level: ThreatLevel) => void
}

export const useThreatLevel = create<ThreatState>((set) => ({
  level: 'quiet',
  setLevel: (level) => set({ level }),
}))
